import * as React from 'react'
import { IconsModel } from './iconsModel'

function SvgApartment(
	{
		color,
		width = 96,
		height = 96
	}: IconsModel
) {
	return (
		<svg width={width} height={height} viewBox="0 0 308.99 276.93">
			<defs>
				<style>{`.cls-1{fill:${color}`}</style>
			</defs>
			<polygon className="cls-1" points="262.28 84.67 252.28 84.67 252.28 250.86 214.33 267.8 218.41 276.93 257.28 259.58 296.16 276.93 300.24 267.8 262.28 250.86 262.28 84.67" />
			<path className="cls-1"
			      d="M99,184.2a20.43,20.43,0,0,1,20.41-20.4H221a20.42,20.42,0,0,1,20.41,20.4v23.09h10V184.2A30.44,30.44,0,0,0,221,153.8H119.36A30.45,30.45,0,0,0,89,184.2v23.09H99Z"
			      transform="translate(-58.1 -74.13)" />
			<path className="cls-1"
			      d="M277.82,266.6l.16-.35a35.86,35.86,0,1,0-69.24-13.09v8.62H129.81v-8.62a35.86,35.86,0,1,0-69.24,13.09l33,68.25h19v16.24h10V334.5h95.26v16.24h10V334.5H245Zm-178,57.9-30-62.07a25.86,25.86,0,1,1,50-9.27v18.62h98.93V253.16a25.85,25.85,0,0,1,51.7,0,25.61,25.61,0,0,1-1.71,9.27l-30,62.07Z"
			      transform="translate(-58.1 -74.13)" />
			<path className="cls-1" d="M329.34,74.13H301.43l-37.75,74.23H367.09Z" transform="translate(-58.1 -74.13)" />
		</svg>
	)
}

export default SvgApartment
